import React from 'react';

// Placeholder that mimics an image/video card while data loads.
export const SkeletonCard = () => (
    <div className="rounded-xl overflow-hidden shadow-e0 bg-white dark:bg-gray-800 border border-gray-100 dark:border-gray-700 animate-pulse">
        <div className="w-full h-56 bg-gray-200 dark:bg-gray-700" />
        <div className="p-4 space-y-3">
            <div className="h-4 w-2/3 bg-gray-200 dark:bg-gray-700 rounded" />
            <div className="h-3 w-1/2 bg-gray-200 dark:bg-gray-700 rounded" />
            <div className="h-3 w-1/3 bg-gray-200 dark:bg-gray-700 rounded" />
        </div>
    </div>
);

// A responsive grid of skeleton cards — drop-in for a loading gallery.
export const SkeletonGrid = ({ count = 6 }) => (
    <div className="grid sm:grid-cols-2 md:grid-cols-3 grid-cols-1 gap-6 mt-4">
        {Array.from({ length: count }).map((_, i) => (
            <SkeletonCard key={i} />
        ))}
    </div>
);

export default SkeletonCard;
